
import React from 'react';

const border_div_style = {
  marginTop: "2rem",
  borderTop: "1px solid black",
};

const Header = props => {
  return (<div style={{ fontWeight: "800", fontSize: "1.5rem"}}>{props.text}</div>);
};

export { Header, border_div_style };
